<template>
  <button class="card-validate" @click="routerPage">
    <div class="card-validate__div">
      <div class="card-validate__photo">
        <img
          class="img-fluid"
          :src="getPhotoProfile"
          :alt="`foto professional ${professional.data.name}`"
          :title="`foto professional ${professional.data.name}`"
        />
      </div>
      <div class="card-validate__information">
        <h2 class="card-validate__title" v-if="hasCodeNameOrName">
          {{ professional.data?.code_name || professional.data?.name }}
        </h2>
        <h3 class="card-validate__subtitle" v-if="hasProminentProfession">
          {{ professional.data.prominent_profession }}
        </h3>
        <div class="card-validate__document" v-if="hasDocument">
          <img
            class="img-fluid"
            src="@/assets/img/icon-document.png"
            alt="icon document"
            title="icon document"
          />
          <p>
            <span v-if="professional.data.document_name"
              >{{ professional.data.document_name }}: </span
            >{{ professional.data.document_number }}
          </p>
        </div>
      </div>
    </div>
    <div class="card-validate-status">
      <div
        class="card-validate-status__element"
        :class="{ 'card-validate-status--valid': hasProfissionalWorkInCompany }"
      >
        <img
          v-if="hasProfissionalWorkInCompany"
          class="img-fluid"
          src="@/assets/img/checked.png"
          alt="icon checked"
          title="icon checked"
        />
        <img
          v-else
          class="img-fluid"
          src="@/assets/img/close-modal.png"
          alt="icon close"
          title="icon close"
        />
        <p class="card-validate-status__text">
          <template v-if="hasProfissionalWorkInCompany"> Atende </template>
          <template v-else>Não atende</template>
        </p>
      </div>
    </div>
  </button>
</template>

<script>
export default {
  props: {
    professional: {
      type: Object,
      required: true,
    },
  },
  computed: {
    hasProfessional() {
      return (
        this.professional?.data &&
        Object.keys(this.professional.data).length > 0
      );
    },
    hasProfissionalWorkInCompany() {
      return (
        this.hasProfessional &&
        this.professional?.companyHasProfessional &&
        Object.keys(this.professional.companyHasProfessional).length > 0
      );
    },
    hasCodeNameOrName() {
      return (
        this.hasProfessional &&
        (this.professional.data?.code_name || this.professional.data?.name)
      );
    },
    hasProminentProfession() {
      return (
        this.hasProfessional && this.professional.data?.prominent_profession
      );
    },
    hasDocument() {
      return this.hasProfessional && this.professional.data?.document_number;
    },
    getPhotoProfile() {
      return (
        (this.professional?.data?.profile_photo_file_path ??
          this.professional?.data?.photo_url) ||
        require("@/assets/img/image-user-google.png")
      );
    },
  },
  methods: {
    routerPage() {
      if (!this.hasProfissionalWorkInCompany) {
        this.$router.push({
          name: "RegisterProfessionalCompany",
          params: {
            id: this.$route.params.id,
            slug: this.$route.params.slug,
            idProfessional: this.professional.data.id,
          },
        });

        return;
      }

      this.$router.push({
        name: "EditProfessionalCompany",
        params: {
          id: this.$route.params.id,
          slug: this.$route.params.slug,
          idProfessional: this.professional.data.id,
          idCompanyHasProfessional: this.professional.companyHasProfessional.id,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.card-validate {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  padding: 20px;
  background: var(--white);
  border-radius: 20px;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
  border: 0;
  &-status {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 10px;
    &__element {
      display: flex;
      align-items: center;
      gap: 5px;
    }
    img {
      max-width: 15px;
    }
    &__text {
      font-size: 12px;
      font-family: "Font Semibold";
      color: var(--red-dark);
      margin-bottom: 0;
    }
    &--valid {
      .card-validate-status__text {
        color: var(--green) !important;
      }
    }
  }
  &__div {
    display: flex;
    align-items: center;
    gap: 30px;
    border-bottom: 1px solid var(--gray-1);
    padding-bottom: 10px;
  }
  &__photo {
    margin-bottom: 20px;
    img {
      border-radius: 100%;
      max-width: 60px;
      max-height: 60px;
      object-fit: cover;
    }
  }
  &__information {
    text-align: left;
  }
  &__title {
    font-size: 16px;
    font-family: "Font Semibold";
    color: var(--black);
    margin-bottom: 10px;
  }
  &__subtitle {
    font-size: 14px;
    font-family: "Font Regular";
    color: var(--gray-dark);
  }
  &__document {
    display: flex;
    align-items: center;
    gap: 5px;
    img {
      max-width: 20px;
    }
    p {
      font-size: 12px;
      color: var(--black);
      font-family: "Font Regular";
      margin-bottom: 0;
      span {
        font-family: "Font Semibold";
      }
    }
  }
  &-formation {
    padding-top: 20px;
    text-align: left;
    &__title {
      font-size: 14px;
      font-family: "Font Semibold";
      color: var(--black);
      margin-bottom: 15px;
    }
  }
}
</style>
